export default "__VITE_ASSET___5DbxiHU__"